<app-navbar></app-navbar>

<section class="premium-3d-single-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <ng-container *ngIf="foundnews != null">
                    <!-- The Ultimate 3D Glassmorphic Card -->
                    <div class="ultimate-3d-card">
                        <!-- Top Image Area (if any) -->
                        <div class="card-image-header" *ngIf="foundnews.ShowAttachments && foundnews.ShowAttachments.length > 0">
                            <img class="img-fluid w-100" [src]="foundnews.ShowAttachments[0].FilePath" alt="{{ foundnews.TitleEn }}" />
                            <!-- Floating Glass Date Badge over the image -->
                            <div class="floating-glass-badge">
                                <i class="fa-regular fa-calendar-alt me-2"></i> {{ foundnews.CurrentDate | date : "MMM d, yyyy" }}
                            </div>
                        </div>

                        <!-- Content Area -->
                        <div class="card-content-body">
                            <h1 class="ultimate-3d-title mb-5 text-center">
                                {{ foundnews.TitleBn || foundnews.TitleEn }}
                            </h1>
                            
                            <!-- Header Fallback if no images -->
                            <div class="text-center mb-4" *ngIf="!foundnews.ShowAttachments || foundnews.ShowAttachments.length === 0">
                                <div class="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill mb-3" style="font-size: 14px;">
                                    <i class="fa-regular fa-calendar-alt me-2"></i> {{ foundnews.CurrentDate | date : "MMMM d, yyyy" }}
                                </div>
                            </div>
                            
                            <div class="ultimate-text-content mb-5" *ngIf="foundnews.DetailsBn || foundnews.DetailsEn">
                                <div [innerHTML]="foundnews.DetailsBn || foundnews.DetailsEn"></div>
                            </div>

                            <!-- Additional Gallery Images -->
                            <div class="gallery-container mt-5" *ngIf="foundnews.ShowAttachments && foundnews.ShowAttachments.length > 1">
                                <h4 class="mb-4 fw-bold" style="color: #0f4c3a;">অতিরিক্ত ছবি</h4>
                                <div class="row g-3">
                                    <div class="col-md-4 col-sm-6" *ngFor="let image of foundnews.ShowAttachments | slice:1">
                                        <div class="gallery-image-card">
                                            <a [href]="image.FilePath" target="_blank" class="d-block h-100 w-100">
                                                <img [src]="image.FilePath" class="img-fluid rounded shadow-sm w-100 h-100 object-fit-cover" style="min-height: 150px; border: 2px solid #e2e8f0; transition: transform 0.3s;" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>
